import { render, staticRenderFns } from "./DoubleVisitsReports.vue?vue&type=template&id=5571df32"
import script from "./DoubleVisitsReports.vue?vue&type=script&lang=js"
export * from "./DoubleVisitsReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports